// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC__HNMq62yy78jhM5x9aHQ81sVM_n_7O4",
  authDomain: "mining-9fd4a.firebaseapp.com",
  projectId: "mining-9fd4a",
  storageBucket: "mining-9fd4a.firebasestorage.app",
  messagingSenderId: "320324987693",
  appId: "1:320324987693:web:ca8a399f48406a315e01a4",
  measurementId: "G-K71QNBEEPG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage  = getStorage(app);  
const analytics = getAnalytics(app);